const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const updateTestAccess = async (
  emails = [],
  type,
  topSelectedMajors = [],
  topNonSelectedMajors = [],
) => {
  try {
    const requestBody = {
      emails,
      type,
      topSelectedMajors,
      topNonSelectedMajors,
    };

    const response = await fetch(`${BASE_URL}/api/Account/updateTest`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `updateTest failed. Status: ${response.status}, Message: ${errorText}`,
      );
    }

    const data = await response.json();

    if (data?.success === false || data?.flag === false) {
      throw new Error(
        data?.message || 'updateTest returned an unsuccessful response',
      );
    }

    return data;
  } catch (error) {
    console.error('Error in updateTestAccess:', error.message);
    throw error;
  }
};
